export default '/build/2d21479f.svg'